export default {
  evidence: {
    client_ip: "Client IP",
    list: "Evidence Vestiges List",
    new_content: "New Content",
    old_content: "Old Content",
    request_type: "Request Type",
    time_access: "Time Access",
    update: "Evidence Vestiges Detail",
    uri: "URI",
    user: "User",
    work_content: "Work Content",
    division: "Division Type",
    connection_screen: "Connection Screen",
    before: "Before",
    after: "After",
    status: "Status",
    login_history_update: "Login History Detail",
    sessionId: "Session Id",
    fullName: "Full Name"
  },
}